<template>
  <div>
    <v-dialog v-model="localModal" fullscreen hide-overlay>
      <v-card>
        <v-toolbar color="primary" dense dark>
          <v-toolbar-title>
            {{
              selected._id
                ? $t('titles.global.updateModel', {
                    field: $tc('models.tournament'),
                  })
                : $t('titles.global.newModel', {
                    field: $tc('models.tournament'),
                  })
            }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <!-- <v-btn
              v-if="tournament._id"
              @click="dialogClone = true"
              flat
              class="mr-5"
            >{{$t('titles.tournaments.duplicate')}}</v-btn>-->
            <v-btn
              v-if="selected._id"
              icon
              dark
              :loading="$store.state.tournaments.loading"
              @click="$store.dispatch('tournaments/fetchOne', selected._id)"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn dark icon @click="cancel">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step
              class="cursor"
              :complete="step > 1"
              :step="1"
              @click="tournament._id ? (step = 1) : ''"
            >
              {{ $t('titles.global.generalInformation') }}
            </v-stepper-step>
            <v-divider />
            <v-stepper-step
              class="cursor"
              :complete="step > 2"
              :step="2"
              :disabled="!tournament._id"
              @click="tournament._id ? (step = 2) : ''"
            >
              {{ $t('titles.tournaments.participants') }}
            </v-stepper-step>
            <v-divider />
            <v-stepper-step
              class="cursor"
              :complete="step > 3"
              :step="3"
              :disabled="!tournament._id"
              @click="tournament._id ? (step = 3) : ''"
            >
              {{ $tc('models.phase', 2) }}
            </v-stepper-step>
            <v-divider />
            <v-stepper-step
              class="cursor"
              :complete="step > 4"
              :step="4"
              :disabled="!tournament._id"
              @click="tournament._id ? (step = 4) : ''"
            >
              {{ $tc('models.group', 2) }}
            </v-stepper-step>
            <v-divider />
            <v-stepper-step
              class="cursor"
              :complete="step > 5"
              :step="5"
              :disabled="!tournament._id"
              @click="tournament._id ? (step = 5) : ''"
            >
              {{ $tc('models.match', 2) }}
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content :step="1">
              <tab-information
                ref="tabInformation"
                :tournament="tournament"
                :file.sync="file"
              />
            </v-stepper-content>
            <v-stepper-content :step="2">
              <tab-participants
                :participants="participants"
                :type="tournament.type"
                :limit="Number(tournament.numberParticipants)"
              />
            </v-stepper-content>
            <v-stepper-content :step="3">
              <tab-phases
                :phases="selected.phases ? selected.phases : []"
                :type="tournament.type"
              />
            </v-stepper-content>
            <v-stepper-content :step="4">
              <tab-groups
                :phases="selected.phases ? selected.phases : []"
                :type="tournament.type"
              />
            </v-stepper-content>
            <v-stepper-content :step="5">
              <tab-matches :tournament="selected" tournament-view />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-card-actions>
          <template>
            <span style="color: red">(*) &nbsp;</span>
            <span>{{ $t('action.messages.fieldRequired') }}</span>
          </template>
          <v-spacer />
          <template v-if="step === 1">
            <meta-button
              v-if="!tournament._id"
              type="create"
              :loading="loading"
              @click="submit()"
            />
            <meta-button
              v-else
              type="update"
              :loading="loading"
              @click="submit()"
            />
          </template>
          <v-btn v-if="step > 1" small color="success" @click="step--">
            &lt;&lt; {{ $t('titles.global.previous') }}
          </v-btn>
          <v-btn
            v-if="tournament._id && step < 5"
            small
            color="success"
            @click="step++"
          >
            {{ $t('titles.global.next') }} &gt;&gt;
          </v-btn>
          <!-- <meta-button @click="clear" type="reset" :disabled="loading" /> -->
          <meta-button type="cancel" @click="cancel" />
        </v-card-actions>
      </v-card>
      <!-- <v-dialog v-model="dialogClone" max-width="400">
        <v-card>
          <v-card-title class="headline">{{$t('confirmation')}}</v-card-title>
          <v-card-text
            v-html="$t('titles.global.confirmADelete', {field: $tc('models.tournament')})"
          ></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              @click="dialogClone = false"
              small
            >{{$t('action.buttons.cancel')}}</v-btn>

            <v-btn color="success" @click="clone()" small>
              <span v-if="loading">
                <v-progress-circular :size="20" :width="3" color="#FFFFFF" indeterminate></v-progress-circular>
              </span>
              <span v-else>{{$t('titles.tournaments.duplicate')}}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>-->
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TabGroups from './form/TabGroups'
import TabInformation from './form/TabInformation'
import TabParticipants from './form/TabParticipants'
import TabPhases from './form/TabPhases'
import TabMatches from '@/components/apps/matches/Dashboard'
import { formatDatePicker } from '@/helpers/dateHelper'
import { parseObject } from '@/helpers/utils'
export default {
  name: 'FormManager',
  components: {
    TabInformation,
    TabParticipants,
    TabPhases,
    TabGroups,
    TabMatches,
  },
  props: {
    modal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      step: 1,
      dialogClone: false,
      tournament: {},
      file: '',
    }
  },
  watch: {
    selected: {
      handler: function (val) {
        this.setObject(val)
        if (this.tournament._id !== val._id) this.step = 1
      },
      immediate: true,
      deep: true,
    },
    'tournament.type': {
      handler: function (val, oldVal) {
        if (val === 'teams' && oldVal === 'users') this.tournament.users = []
        else if (val === 'users' && oldVal === 'teams') {
          this.tournament.teams = []
        }
      },
    },
  },
  mounted() {
    this.setObject(this.selected)
  },

  computed: {
    ...mapState({
      selected: (state) => state.tournaments.selected,
      loading: (state) => state.tournaments.loading,
    }),
    localModal: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) this.$emit('close')
      },
    },
    participants() {
      let participants = []
      if (this.tournament.type === 'teams') {
        participants = Array.from(this.selected.teams)
      } else if (this.tournament.type === 'users') {
        participants = Array.from(this.selected.users)
      }
      return participants
    },
  },
  methods: {
    ...mapActions({
      setCreate: 'tournaments/create',
      setUpdate: 'tournaments/update',
      fetchOne: 'tournaments/fetchOne',
      reset: 'tournaments/reset',
      uploadFile: 'files/uploadPush',
    }),
    submit() {
      this.$nextTick((_) => {
        this.$refs.tabInformation.customValidate().then((valid) => {
          if (valid.some((valid) => !valid)) return
          let payload = Object.assign({}, this.tournament)
          delete payload.teams
          delete payload.users
          delete payload.phases
          if (!payload._id) {
            this.setCreate(payload).then(async (item) => {
              if (this.file) {
                await this.uploadFile({
                  id: item._id,
                  model: 'Tournaments',
                  field: 'img',
                  file: this.file,
                })
              }
              this.fetchOne(item._id)
              // this.cancel()
            })
          } else {
            this.setUpdate(payload).then(async (item) => {
              if (this.file) {
                await this.uploadFile({
                  id: item._id,
                  model: 'Tournaments',
                  field: 'img',
                  file: this.file,
                })
              }
              this.fetchOne(item._id)
              // this.cancel()
            })
          }
        })
      })
    },
    setObject(tournament) {
      this.tournament = parseObject({
        ...tournament,
        startAt: tournament.startAt || '',
        endAt: tournament.endAt || '',
      })
      this.tournament.startAt = formatDatePicker(tournament.startAt)
      this.tournament.endAt = formatDatePicker(tournament.endAt)
      if (this.tournament.stadiumId && this.tournament.stadiumId.length) {
        let params = {
          _id: this.tournament.stadiumId,
        }
        this.$store.dispatch('stadiums/fetchSelectList', params)
      }
    },
    // clone () {
    //   let validate = this.validateTournament()
    //   if (!validate.error) {
    //     return
    //   }
    //   let tournament = this.createTournamet()
    //   delete tournament._id
    //   tournament.users = this.selected.users.slice()
    //   tournament.teams = this.selected.teams.slice()
    //   tournament.phases = this.selected.phases.slice()

    //   tournament.name.forEach(item => delete item._id)
    //   tournament.description.forEach(item => delete item._id)
    //   tournament.users.forEach(item => delete item._id)
    //   tournament.teams.forEach(item => delete item._id)
    //   tournament.phases.forEach(phase => {
    //     delete phase._id
    //     phase.name.forEach(item => delete item._id)
    //     phase.groups.forEach(group => {
    //       group.name.forEach(item => delete item._id)
    //       delete group._id
    //     })
    //   })
    //   let spanishLang = tournament.name.find(
    //     lang => lang.iso === this.defaultISO
    //   )
    //   spanishLang.text += ' (copy)'
    //   this.loading = true
    //   this.setNew(tournament)
    //     .then(() => {
    //       this.dialogClone = false
    //     })
    //     .finally(() => {
    //       this.loading = false
    //     })
    // },
    clear() {
      this.$nextTick((_) => {
        this.step = 1
        this.reset()
        if (this.$refs.tabInformation) this.$refs.tabInformation.clear()
      })
    },
    cancel() {
      this.$emit('close')
      // this.clear()
    },
  },
}
</script>
